import script from "./RequestBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestBuilder.vue?vue&type=script&setup=true&lang=js"

import "./RequestBuilder.vue?vue&type=style&index=0&id=1e05dc74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e05dc74"]])

export default __exports__